<template>
  <div ref="observerTarget">
    <div v-if="data && data.length">
      <div class="row" v-for="(review, index) in data" :key="review.id">
        <div class="col-12 col-lg-3 mb-3 mb-lg-0 d-flex d-lg-block">
          <div class="ms-auto ms-lg-0 me-lg-3 order-2 order-lg-1 mb-3">
            <small v-if="review.rating === 10" class="badge rounded-pill text-success bg-success-subtle">
              <span class="text-capitalize">{{ 'recommended' | translate }}</span>
              <i class="fas fa-thumbs-up"></i>
            </small>
            <small v-else-if="review.rating === 5" class="badge rounded-pill text-secondary bg-secondary-subtle">
              <span class="text-capitalize">{{ 'neutral' | translate }}</span>
            </small>
            <small v-else-if="review.rating === 0" class="badge rounded-pill text-secondary bg-secondary-subtle">
              <span class="text-capitalize">{{ 'not recommended' | translate }}</span>
              <i class="fas fa-thumbs-down"></i>
            </small>
          </div>
          <div class="order-1 order-lg-2">
            <div class="">
              {{ review.first_name }}
            </div>
            <div class="text-muted small">
              {{ humanDate(review.created_at) }}
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-9">
          <figure class="m-0">
            <blockquote class="blockquote mb-2" :class="!review.review ? 'text-muted fst-italic' : ''">
              <p class="small">
                <i class="fas fa-quote-left me-2 text-warning" v-if="review.review"></i>
                {{ review.review || 'No descriptive opinion' | translate }}
              </p>
            </blockquote>
            <figcaption class="blockquote-footer m-0">
              <a :href="`/${review.course.slug}`" class="text-muted">{{ review.title }}</a>
            </figcaption>
          </figure>
          <hr v-if="index !== data.length - 1" class="my-5" />
        </div>
      </div>
      <div class="row mt-5" v-if="next_page_url">
        <div class="col text-center">
          <button @click="loadMore" class="btn btn-sm btn-outline-dark px-4 text-capitalize">
            {{ 'More' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div v-else-if="data && !data.length" class="text-center">
      {{ 'No reviews yet' | translate }}. <a class="text-dark" href="/login"><u>{{ 'Log in to be the first to share your thoughts' | translate }}!</u></a>
    </div>

    <div v-else-if="!data && !loaded">
      <Spinner class="d-flex align-items-center"></Spinner>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import Spinner from '~/app2/components/Spinner'

export default {
  props: ['product', 'length'],
  components: {
    Spinner,
  },
  data() {
    return {
      data: null,
      observer: null,
      loaded: false,
      next_page_url: null,
    }
  },
  methods: {
    humanDate(date) {
      return date ? dayjs(date).fromNow() : ''
    },
    useSameProtocol(url) {
      if (!url) {
        return null
      }
      return url.replace('http:', window.location.protocol)
    },
    loadMore() {
      if (this.next_page_url) {
        axios
          .post(this.next_page_url, { course_id: this.product || null, length: this.length || null })
          .then(({ data }) => {
            this.data = this.data.concat(data.data)
            this.next_page_url = this.useSameProtocol(data.next_page_url)
          })
      }
    },
  },
  mounted() {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.loaded) {
          axios
            .post('/json/reviews', { course_id: this.product || null, length: this.length || null })
            .then(({ data }) => {
              this.data = data.data
              this.loaded = true
              this.next_page_url = this.useSameProtocol(data.next_page_url)
            })
        }
      },
      {
        rootMargin: '250px',
      },
    )

    this.observer.observe(this.$refs.observerTarget)
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
}
</script>

<style></style>
